import { gql } from '@apollo/client';
import { DocumentFragment } from 'approot/shared/graphql/document/document.graphql';

export const assessmentForLearningToolFragment = gql`
  fragment AssessmentForLearningToolFragment on Assessment {
    id
    assessmentForLearningTool {
      id
      documentType
      document {
        ...documentFragment
      }
    }
  }
  ${DocumentFragment}
`;

export const ADD_ASSESSMENT_FOR_LEARNING_TOOL = gql`
  mutation AddAssessmentForLearningTool(
    $input: AddAssessmentContentDocumentInput!
  ) {
    addAssessmentForLearningTool(input: $input) {
      id
      ...AssessmentForLearningToolFragment
    }
  }
  ${assessmentForLearningToolFragment}
`;

export const DELETE_ASSESSMENT_FOR_LEARNING_TOOL = gql`
  mutation DeleteAssessmentForLearningTool(
    $input: DeleteAssessmentContentDocumentInput!
  ) {
    deleteAssessmentForLearningTool(input: $input) {
      id
      ...AssessmentForLearningToolFragment
    }
  }
  ${assessmentForLearningToolFragment}
`;
